import { UserProfile } from 'models/user.types';

/** Matches the backend signup allowlist for legacy pending and unfinished freemium accounts. */
export const isSignupInProgress = (
  user: Pick<UserProfile, 'status' | 'onboardingComplete'>
): boolean => user.status === 'pending' || user.onboardingComplete === false;
